import { useAutoSwitch } from "../hooks/useAutoSwitch";

interface BlueprintErrorHandlerProps {
  isTooFarFromCity: boolean;
  isExpandingForceField: boolean;
  forceFieldError: string | null;
  isEnemyTerritory: boolean;
  onAddWaypoint: () => void;
  children: React.ReactNode;
}

// TODO: rename to BlueprintWrapper or similar
export function BlueprintErrorHandler({
  isTooFarFromCity,
  isExpandingForceField,
  forceFieldError,
  isEnemyTerritory,
  onAddWaypoint,
  children,
}: BlueprintErrorHandlerProps) {
  useAutoSwitch();

  if (isTooFarFromCity) {
    return (
      <p className="text-left text-white/70 uppercase leading-normal">
        You&apos;re too far from Permutation City. Come to{" "}
        <button
          type="button"
          className="text-[#FAE792]"
          onClick={onAddWaypoint}
        >
          (569, 147, -1519)
        </button>{" "}
        to build the city.
      </p>
    );
  }

  if (isExpandingForceField) {
    return (
      <p className="text-left text-white/70 uppercase leading-normal">
        Expanding force field...
      </p>
    );
  }

  if (forceFieldError) {
    return (
      <p className="text-left text-white/70 uppercase leading-normal">
        {forceFieldError}
      </p>
    );
  }

  if (isEnemyTerritory) {
    return (
      <p className="text-left text-white/70 uppercase leading-normal">
        You cannot build in enemy territory. Destroy the enemy force field
        first.
      </p>
    );
  }

  return <>{children}</>;
}
